import RefIndex from './views/index';
import RefNew from './views/new';
import RefEdit from './views/edit';


export default [
    {
        path: '/refs',
        name: 'RefIndex',
        component: RefIndex,
        meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 1}
    },
    {
        path: '/refs/new',
        name: 'RefNew',
        component: RefNew,
        meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 2, isProtected: true, feature: 'create_sight_ref'}
    },
    {
        path: '/refs/:id',
        name: 'RefEdit',
        component: RefEdit,
        meta: {layout: "layoutUser", pageOrder: 2, pageSubOrder: 2}
    }
];